import React from "react";
import {IconButton, Tooltip} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import {useHistory} from "react-router";

const Header = () => {
    const history = useHistory();

    function onClickBack() {
        history.goBack();
    }

    return (
        <div style={{
            padding: "5px 15px",
            borderBottom: '1px solid #dedede',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }}>
            <Tooltip title={"Exit from Application Builder"}>
                <IconButton style={{padding: 3}} onClick={onClickBack}>
                    <CloseIcon/>
                </IconButton>
            </Tooltip>
            <Typography variant={"body2"} color={'textSecondary'}>Sysbu Application builder 2.0</Typography>
        </div>
    )
}
export default Header